module.exports = __webpack_public_path__ + "img/creative-guy.eff00c99.svg";